import React from "react";
import FormDialog from "../../shared/FormDialog";
import { Box, Grid, Typography } from "@material-ui/core";
import CustomTextField from "../../shared/CustomTextField";
import { webUserTextFields } from "./webUserFormLabel";
import useRegistration from "./hook/useRegistration";
import getInputError from "../../messages/inputsValidation";
import ButtonNav from "../../shared/NavBar/ButtonNav";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const getShrink = (value: string) => ({ shrink: Boolean(value) });

const Registration: React.FC<IProps> = ({ open, onClose }: IProps) => {
  const { webUserData, register, errors, onSubmit } = useRegistration(onClose);
  return (
    <FormDialog open={open} title={`Rejestracja`} onClose={onClose} showTitle={true} hideActions={true}>
      <Box my={3} style={{ width: "60%", marginLeft: "20%" }}>
        <form onSubmit={onSubmit}>
          <Grid container spacing={3}>
            {webUserTextFields.map(({ name, label, validator, type }, index) => (
              <Grid key={index} item xs={12}>
                <CustomTextField
                  InputLabelProps={getShrink(webUserData[name])}
                  error={Boolean(errors.name)}
                  helperText={errors.name ? getInputError(errors, "name") : " "}
                  label={`${label}*`}
                  name={name}
                  type={type ? type : "text"}
                  inputRef={validator ? register(validator) : register}
                  fullWidth
                />
              </Grid>
            ))}
            <Grid item xs={12}>
              <Typography>* - pola wymagane</Typography>
            </Grid>
          </Grid>
          <ButtonNav type={"button"} onClick={onSubmit} fullWidth={true}>
            Zarejestruj
          </ButtonNav>
        </form>
      </Box>
    </FormDialog>
  );
};

export default Registration;
